import React from 'react'
import styled from 'styled-components/macro'
import { Header5, Paragraph, ParagraphSecondary, Row, Spaced, AnchorGolden, SpacedMicro } from '.'
import { Employee } from '../services/useEmployees'
import { Line } from './Line'

const BORDER_WIDTH = 5 // if this is changed recompute the length of path using path.getTotalLength() and set in SC below
const svgViewSize = 267 + 2 * BORDER_WIDTH

const formatImageUrl = (url: string) =>
  `${process.env.REACT_APP_MEDIA_HOST}${url}?width=267&height=267&mode=crop&quality=70`

export const EmployeeCard: React.FC<Employee> = ({ Name, Titel, Desc, Image, LinkedIn, Email, Phone, Url }) => (
  <Card>
    <Spaced bottom>
      <PictureFrame href={Url}>
        <ProfilePicture src={formatImageUrl(Image.url)} alt={Name} />
        <PictureBorder
          width={svgViewSize}
          height={svgViewSize}
          viewBox={`0 0 ${svgViewSize} ${svgViewSize}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d={`M${BORDER_WIDTH} ${BORDER_WIDTH / 2}H${svgViewSize - BORDER_WIDTH / 2}V${
              svgViewSize - BORDER_WIDTH / 2
            }H${BORDER_WIDTH / 2}V${BORDER_WIDTH / 2}Z`}
            stroke="#FFCB05"
            strokeWidth={BORDER_WIDTH}
          />
        </PictureBorder>
      </PictureFrame>

      <div style={{ marginBottom: 8 }}>
        <Header5>{Name}</Header5>
        <ParagraphSecondary>{Titel}</ParagraphSecondary>
      </div>

      <Paragraph style={{ marginBottom: 'auto', paddingBottom: 16 }}>{Desc}</Paragraph>

      <Line />

      <div>
        <SpacedMicro bottom>
          <a href={`tel:${Phone}`}>
            <Row align="center">
              <SpacedMicro right>
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 184.3 239.1" size="16px">
                  <path d="M84.6 16.1L96 49.7c3.6 10.6-1.5 22.9-11.5 27.9l-14 6.9c-.4.2-.7 1.1-.4 2 .5 1.6 1.7 4.9 3.8 9.7 3.5 8.1 8 17.2 13.6 27 5.7 9.8 11.3 18.3 16.6 25.3 3.1 4.1 5.4 6.9 6.9 8.6.2.3 1.1.4 1.4.1l9.8-6.7c9.1-6.2 22.1-5 29.9 2.8l25.8 25.9c7.7 7.8 8.7 20.5 2.4 29.4-1.3 2.1-3.5 5-6.8 8.5-5.7 6-12.9 11.8-21.9 17-30.9 17.8-87.2-12.3-124-76.2s-34.8-127.7-4-145.5c9-5.2 17.6-8.6 25.6-10.5C53.8.8 57.4.3 59.8.2c10.6-1.3 21.3 5.7 24.8 15.9zm-22.5 5.2l-1.5.1c-.9 0-3.1.3-6.5 1.1-6.1 1.5-12.8 4.1-20 8.2-18.3 10.6-20 61.4 11.8 116.4s76.6 79 94.9 68.4c7.2-4.1 12.8-8.7 17.1-13.2 2.4-2.5 3.8-4.4 4.2-5.1l.7-1.1c.3-.4.3-1.6-.1-1.9l-25.8-25.9c-.5-.5-2.1-.6-2.8-.2l-9.8 6.7c-9.5 6.4-22.7 4.6-29.6-3.8-1.6-1.8-4.3-5-7.9-9.7-5.8-7.7-11.9-16.9-18-27.4-6.1-10.6-11-20.4-14.8-29.3-2.3-5.4-3.8-9.4-4.3-11.2-3.9-10.7 1-23 11.2-28l14-6.9c.5-.2.9-1.4.8-1.9L64.4 23c-.3-.8-1.7-1.8-2.3-1.7z" />
                </Icon>
                <Paragraph>tlf: {Phone}</Paragraph>
              </SpacedMicro>
            </Row>
          </a>

          <a href={`mailto:${Email}`}>
            <Row align="center">
              <SpacedMicro right>
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" size="16px">
                  <path d="M50,0H206c27.61,0,50,22.39,50,50V206c0,27.61-22.39,50-50,50H50c-27.61,0-50-22.39-50-50V50C0,22.39,22.39,0,50,0Zm0,23c-14.91,0-27,12.09-27,27V206c0,14.91,12.09,27,27,27H206c14.91,0,27-12.09,27-27V50c0-14.91-12.09-27-27-27H50Zm-27,27L110.96,115.22c8.68,6.43,20.5,6.57,29.32,.33L233,50v31l-92.72,65.55c-8.82,6.24-20.65,6.1-29.32-.33L23,81v-31Z" />
                </Icon>
                <Paragraph>{Email}</Paragraph>
              </SpacedMicro>
            </Row>
          </a>
        </SpacedMicro>
      </div>

      <Row style={{ minHeight: 24 }}>
        {LinkedIn !== '' && (
          <AnchorGolden href={LinkedIn}>
            <ClickableIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
              <path
                fill="#FFCB05"
                d="M128 256C57.3 256 0 198.7 0 128S57.3 0 128 0s128 57.3 128 128-57.3 128-128 128zm0-23.3c57.8 0 104.7-46.9 104.7-104.7S185.8 23.3 128 23.3 23.3 70.2 23.3 128 70.2 232.7 128 232.7zm-28.2-55H76.3v-70.3h23.5v70.3zM88 97.8h-.2c-7.9 0-13-5.4-13-12.2 0-6.9 5.3-12.1 13.3-12.1s13 5.2 13.2 12.1c0 6.8-5.1 12.2-13.3 12.2zm96.6 79.9h-23.5v-37.6c0-9.5-3.4-15.9-11.9-15.9-6.5 0-10.4 4.4-12.1 8.6-.6 1.5-.8 3.6-.8 5.7v39.3h-23.5s.3-63.7 0-70.3h23.5v10c3.1-4.8 8.7-11.6 21.2-11.6 15.5 0 27.1 10 27.1 31.6v40.2z"
              />
            </ClickableIcon>
          </AnchorGolden>
        )}
      </Row>
    </Spaced>
  </Card>
)

const Card = styled.div`
  width: 267px;
  max-width: 267px;
  display: flex;
  flex-direction: column;
`

const PictureFrame = styled.a`
  display: block;
  position: relative;

  &:hover svg {
    stroke-dashoffset: 0;
  }
`

const ProfilePicture = styled.img`
  filter: grayscale(100%);
`

const PictureBorder = styled.svg`
  position: absolute;
  z-index: 0;
  top: -5px;
  left: -5px;

  transition: stroke-dashoffset 500ms cubic-bezier(0.45, 0, 0.55, 1);

  stroke-dasharray: 1088;
  stroke-dashoffset: 1088;
`

const Icon = styled.svg<{ size?: string }>`
  width: ${(p) => p.size ?? '24px'};
  height: ${(p) => p.size ?? '24px'};
`

const ClickableIcon = styled(Icon)`
  transition: transform 150ms ease-out;
  transform: scale(1);
  transform-origin: center;

  &:hover {
    transform: scale(1.15);
  }
`
